import {symbol} from '../path/shapes';
import {intersectPoint} from '../util/intersect';
import markItemPath from './markItemPath';

export default markItemPath('symbol', symbol, intersectPoint);
